// src/components/AuthButton.js
import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import Button, { ButtonProps } from '@mui/material/Button'

export const LoginButton = () => {
  let { loginWithRedirect } = useAuth0()

  return <button onClick={() => loginWithRedirect()}>Log In</button>
}

interface CustomButtonProps extends ButtonProps {
  text?: string
}

export const LogoutButton = ({
  text = 'Log Out',
  // eslint-disable-next-line fp/no-rest-parameters
  ...muiButtonProps
}: CustomButtonProps) => {
  let { logout } = useAuth0()

  return (
    <Button
      onClick={() =>
        logout({
          logoutParams: {
            returnTo: import.meta.env.VITE_AUTH0_LOGOUT_REDIRECT_URI,
          },
        })
      }
      {...muiButtonProps}
    >
      {text}
    </Button>
  )
}
